// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  getDoc,
  doc,
  setDoc,
  orderBy,
  limit,
  updateDoc,
  Timestamp,
  onSnapshot,
  startAfter,
  getDocsFromServer,
  getAggregateFromServer,
  average,
  count,
  sum
} from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASEURL,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID
};

// Initialize Firebase
const firebase_app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

const firestore = getFirestore(firebase_app);

const initFirebase = ({ config }) => {
  const firebase = initializeApp(config);
  const firestore = getFirestore(firebase);

  return {
    firebase,
    firestore
  };
};

export {
  initFirebase,
  firebase_app,
  firestore,
  ref,
  uploadBytes,
  collection,
  query,
  where,
  doc,
  addDoc,
  getDoc,
  getDocs,
  setDoc,
  orderBy,
  limit,
  updateDoc,
  Timestamp,
  onSnapshot,
  startAfter,
  getDocsFromServer,
  getAggregateFromServer,
  average,
  count,
  sum
};
